import { useState, useEffect } from 'react'
import PaginaLegale from './PaginaLegale'
import { supabase, funzioneUrl } from '../lib/supabase'
import { useAuth } from '../lib/AuthContext'

// Solo ciò che il piano Free NON include: gruppi/atleti illimitati e la funzione Adesioni.
// Tutto il resto (sessioni, calendario, report, messaggi) è disponibile anche nel piano Free,
// entro i limiti di 1 gruppo e 3 atleti: elencarlo qui darebbe l'impressione di pagare per averlo.
const FUNZIONI_PREMIUM = [
  'Gruppi illimitati (il piano Free ne include 1)',
  'Atleti illimitati (il piano Free ne include 3 per gruppo)',
  'Funzione Adesioni per la gestione presenze',
]

const FUNZIONI_INCLUSE_FREE = [
  'Crea sessioni con blocchi multipli',
  'Assegna sessioni al calendario',
  'Vede i risultati dei tuoi atleti',
  'Report progressi per atleta',
  'Messaggi al gruppo',
]

export default function PaginaAbbonamento({ onChiudi }) {
  const { esci } = useAuth()
  const [caricamento, setCaricamento] = useState(false)
  const [errore, setErrore] = useState('')
  const [paginaLegale, setPaginaLegale] = useState(null)

  const params = new URLSearchParams(window.location.search)
  const pagamentoEsito = params.get('pagamento')

  useEffect(() => {
    if (pagamentoEsito === 'successo') {
      supabase.auth.signOut()
    }
    if (pagamentoEsito === 'annullato' || pagamentoEsito === 'successo') {
      window.history.replaceState({}, '', '/')
    }
  }, [])

  if (pagamentoEsito === 'successo') {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 24, textAlign: 'center' }}>
        <div style={{ fontSize: 64, marginBottom: 16 }}>🎉</div>
        <h2 style={{ fontSize: 24, marginBottom: 8 }}>Pagamento completato!</h2>
        <div style={{ fontSize: 14, color: 'var(--muted)', marginBottom: 32, lineHeight: 1.6 }}>
          Il tuo abbonamento Premium è attivo.<br />Accedi per entrare nell'app.
        </div>
        <button className="btn btn-primary" style={{ maxWidth: 280 }}
          onClick={() => window.location.href = '/?pagamento=successo'}>
          Vai al login →
        </button>
      </div>
    )
  }

  if (paginaLegale) return <PaginaLegale tipo={paginaLegale} onChiudi={() => setPaginaLegale(null)} />

  async function avviaPagamento() {
    setCaricamento(true)
    setErrore('')
    try {
      const { data: { session } } = await supabase.auth.getSession()
      if (!session?.user) throw new Error('Sessione non trovata, rieffettua il login')

      const response = await fetch(
        funzioneUrl('create-checkout-session'),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'apikey': session.access_token,
            'Authorization': `Bearer ${session.access_token}`,
          },
          body: JSON.stringify({ piano: 'coach' }),
        }
      )
      const data = await response.json()
      if (!response.ok) throw new Error(data.error || 'Errore dal server')
      if (!data?.url) throw new Error('URL pagamento non ricevuto')
      await supabase.auth.signOut()
      window.location.href = data.url
    } catch (err) {
      console.error('Errore pagamento:', err)
      setErrore('Errore: ' + err.message)
      setCaricamento(false)
    }
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', padding: '24px 20px' }}>
      <div style={{ maxWidth: 400, margin: '0 auto', width: '100%' }} className="fade-in">
        {/* Chiudi — torna indietro senza abbonarsi */}
        {onChiudi && (
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 4 }}>
            <button onClick={onChiudi} aria-label="Chiudi" style={{
              background: 'none', border: 'none', color: 'var(--muted)', fontSize: 22,
              cursor: 'pointer', padding: 8, lineHeight: 1,
            }}>
              ✕
            </button>
          </div>
        )}

        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <svg viewBox="0 0 226 38" width="192" height="34" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block', margin: '0 auto 8px' }}>
            <circle cx="14" cy="25" r="10" fill="none" stroke="var(--accent)" strokeWidth="3.5"/>
            <circle cx="24" cy="25" r="10" fill="none" stroke="var(--accent)" strokeWidth="3.5"/>
            <text x="41" y="30" fontFamily="Syne, sans-serif" fontWeight="800" fontSize="19" fill="var(--text)">Fit</text>
            <text x="87" y="30" fontFamily="Syne, sans-serif" fontWeight="800" fontSize="19" fill="var(--accent)">Progress</text>
          </svg>
          <div style={{ fontSize: 14, color: 'var(--muted)' }}>Passa a Coach Premium</div>
        </div>

        <div style={{
          border: '2px solid var(--accent)', background: 'rgba(255,255,255,0.04)',
          borderRadius: 16, padding: 20, position: 'relative', marginBottom: 24,
        }}>
          <div style={{ position: 'absolute', top: -10, right: 16, background: 'var(--accent)', color: '#000', fontSize: 10, fontWeight: 700, padding: '3px 10px', borderRadius: 10 }}>
            SENZA LIMITI
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
            <div><div style={{ fontFamily: 'Syne', fontWeight: 800, fontSize: 16 }}>👨‍🏫 Coach Premium</div></div>
            <div style={{ textAlign: 'right' }}>
              <div style={{ fontFamily: 'Syne', fontWeight: 800, fontSize: 28, color: 'var(--accent)', lineHeight: 1 }}>€6</div>
              <div style={{ fontSize: 11, color: 'var(--muted)' }}>/mese</div>
            </div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            {FUNZIONI_PREMIUM.map((f, i) => (
              <div key={i} style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                <span style={{ color: 'var(--accent)', fontSize: 12, flexShrink: 0 }}>✓</span>
                <span style={{ fontSize: 12, color: 'var(--muted)' }}>{f}</span>
              </div>
            ))}
          </div>
          <div style={{ marginTop: 14, paddingTop: 12, borderTop: '1px solid var(--border)' }}>
            <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: 0.5, color: 'var(--muted)', textTransform: 'uppercase', marginBottom: 6 }}>
              Già incluso nel piano Free
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
              {FUNZIONI_INCLUSE_FREE.map((f, i) => (
                <div key={i} style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                  <span style={{ color: 'var(--muted)', fontSize: 12, flexShrink: 0 }}>✓</span>
                  <span style={{ fontSize: 12, color: 'var(--muted)' }}>{f}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div style={{ fontSize: 12, color: 'var(--muted)', textAlign: 'center', marginBottom: 20, lineHeight: 1.6 }}>
          Il piano Free resta gratuito per sempre — fino a 1 gruppo e 3 atleti.
        </div>

        {errore && (
          <div className="alert alert-warn" style={{ marginBottom: 14 }}>
            <span>⚠️</span><span>{errore}</span>
          </div>
        )}

        <button className="btn btn-primary" onClick={avviaPagamento} disabled={caricamento} style={{ fontSize: 16, padding: '16px', marginBottom: 10 }}>
          {caricamento ? '⏳ Attendere...' : '🔒 Abbonati — Coach Premium €6/mese'}
        </button>

        {onChiudi && (
          <button className="btn btn-ghost" onClick={onChiudi} disabled={caricamento} style={{ fontSize: 14, padding: '14px', marginBottom: 10 }}>
            Continua con il piano Free
          </button>
        )}

        <div style={{ textAlign: 'center', fontSize: 11, color: 'var(--muted)' }}>
          Pagamento sicuro via Stripe · Disdici quando vuoi
        </div>
        <div style={{ textAlign: 'center', fontSize: 11, color: 'var(--muted)', marginTop: 8 }}>
          <button onClick={() => setPaginaLegale('privacy')} style={{ background: 'none', border: 'none', color: 'var(--muted)', fontSize: 11, cursor: 'pointer', textDecoration: 'underline' }}>Privacy Policy</button>
          {' · '}
          <button onClick={() => setPaginaLegale('tos')} style={{ background: 'none', border: 'none', color: 'var(--muted)', fontSize: 11, cursor: 'pointer', textDecoration: 'underline' }}>Termini di Servizio</button>
        </div>
        <button onClick={esci} style={{ background: 'none', border: 'none', color: 'var(--muted)', fontSize: 12, cursor: 'pointer', width: '100%', marginTop: 16, textAlign: 'center' }}>
          Esci dall'account
        </button>
      </div>
    </div>
  )
}
